import { render, staticRenderFns } from "./PlacementPicker.vue?vue&type=template&id=d08c8ece&scoped=true"
import script from "./PlacementPicker.vue?vue&type=script&lang=js"
export * from "./PlacementPicker.vue?vue&type=script&lang=js"
import style0 from "./PlacementPicker.vue?vue&type=style&index=0&id=d08c8ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08c8ece",
  null
  
)

export default component.exports